/* eslint-disable no-param-reassign */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import counterpart from 'counterpart';
import {produce} from 'immer';
import OrgSelectorWidgetAccounts from 'Containers/OrgSelectorWidgetAccounts/OrgSelectorWidgetAccounts';
import 'Containers/DataAccessFilter/DataAccessFilter.scss';
import { getAuthenticatedUser } from '../../api/authApi';
import { getUserHierarchyData } from '../../api/getUserHierarchy';
import { GPNOrgTypes, getGpnOrgName, gpnLevelConfig, EVOOrgTypes, HPYOrgTypes, evoLevelConfig, hpyLevelConfig, getHpyOrgName, getEvoOrgName} from 'Utils/organizationAccountsUtils';

class OrgHierarchySelectorAccountsRow extends Component {
  constructor(props) {
    super(props);
    this.state = {
      orgState: props.initialSelections,
      selectedOrgIds: [],
      userResponse:[],
      selectedOrgTypes: [],
      rowKey: props.rowKey,
      isLocked: false,
      isValid: false,
      isMidSearchLocked: false,
      allOption: { label: 'All', mainLine: 'All', id: 'All', hierarchyCode: 'All' },
      SYSTEM_CORP_COUNT: 19,
      EXTERNAL_ROLES: ['MERCHANT_ACCOUNT_ADMINISTRATOR', 'MERCHANT_USER'],
      orgTypeStatusMap: null,
      isCalled:true,
      levelType:{},
      enteredMid: [],
  
    };
    this.attachBindings();
  }

  componentDidMount() {
        if(this.props.canViewEvoAccountsSelector){
      this.setState({
        levelType: EVOOrgTypes,
      });
    } else if(this.props.canViewGpnAccountsSelector){
      this.setState({
        levelType: GPNOrgTypes,
      });
    }else if(this.props.canViewHpyAccountsSelector){
      this.setState({
        levelType: HPYOrgTypes,
      })
    }
    if(this.props.manualSearchMid !== undefined){
      this.setState({enteredMid : this.props.manualSearchMid});
    }

    if(!this.props.receivedCurrentFilter){
      this.onInitializeRow();
    }
  }

  componentWillReceiveProps(nextProps) {
    if(nextProps.prepopulatedMerchantId && this.state.isCalled  && nextProps.prepopulatedMerchantId.length > 9){
      this.setState({ searchTerm: nextProps.prepopulatedMerchantId,isCalled:false,isIdLoading:true });
      this.onLazySearchByMID(nextProps.prepopulatedMerchantId)
    }
    if(nextProps.prepopulatedMerchantId && (nextProps.prepopulatedMerchantId !== this.props.prepopulatedMerchantId)){
      
      this.setState({ searchTerm: nextProps.prepopulatedMerchantId,isCalled:false,isIdLoading:true });
      this.onLazySearchByMID(nextProps.prepopulatedMerchantId)
    }
    
  }

  // initialize the row status when first loading
  onInitializeRow() {
    this.loadInitialHierarchies();
  }

// called when user selects an organization from the dropdown list for any of the tiers in the hierarchy (other than merchant)
  async onOrgSelected(selectedHierarchyId, currentTierType) {
    // do nothing if they reselect the same item already selected
    const prevSelectedItem = this.getSelectedItem(currentTierType);
    if (prevSelectedItem && prevSelectedItem.hierarchyCode === selectedHierarchyId) return;
    this.clearAndResetDescendants(currentTierType);

    if (selectedHierarchyId === counterpart('globalTranslate.globalSelectorFlag.all')) {
      this.updateCurrentTierSelection(currentTierType, null);
      this.updateSelectionStatus();
      this.setState({selectedOrgIds : []}, () => {this.handleHierarchyCallback()});
    } else {
      const itemToSelect = this.findItemToSelect(currentTierType, selectedHierarchyId);
      this.updateCurrentTierSelection(currentTierType, itemToSelect);
      const nextTierType = currentTierType + 1;
      if(this.props.canViewEvoAccountsSelector){
        if (itemToSelect.name === 'group') {
          await this.handleSelection(selectedHierarchyId,0,nextTierType);
        } else if (itemToSelect.name === 'chain') {
          await this.handleSelection(selectedHierarchyId,1,nextTierType);
        } else if (itemToSelect.name === 'tax_id') {
          await this.handleSelection(selectedHierarchyId,2,nextTierType);
        }
      }else if(this.props.canViewGpnAccountsSelector){
          if (itemToSelect.name === 'corporate') { //level6
            await this.handleSelection(selectedHierarchyId,0, nextTierType);
          } else if (itemToSelect.name === 'region') { //level5
            await this.handleSelection(selectedHierarchyId,1, nextTierType);
          } else if (itemToSelect.name === 'principal') { //level4
            await this.handleSelection(selectedHierarchyId,2, nextTierType);
          } else if (itemToSelect.name === 'associate') { //level3
            await this.handleSelection(selectedHierarchyId,3, nextTierType);      
          } else if (itemToSelect.name === 'chain') { //level2
            await this.handleSelection(selectedHierarchyId,4), nextTierType;
          } else if (itemToSelect.name === 'merchant') { //level1
            await this.handleSelection(selectedHierarchyId,5, nextTierType);
          }
      }else if(this.props.canViewHpyAccountsSelector){
        if (itemToSelect.name === 'chain') {
          await this.handleSelection(selectedHierarchyId,0,nextTierType);
        }else if (itemToSelect.name === 'merchant') {
          await this.handleSelection(selectedHierarchyId,1,nextTierType);
        }
      }

      const selectedValues = this.state.orgState.map(e => e.selectedItems);
      this.setState({selectedOrgIds : selectedValues}, () => {this.handleHierarchyCallback()});
    }
  }

  async handleSelection(selectedHierarchyId, levelIndex, nextTierType) {
    const { currentLevel, nextLevel, name, stateLevel } = this.props.canViewGpnAccountsSelector ? gpnLevelConfig[levelIndex] :this.props.canViewHpyAccountsSelector ? hpyLevelConfig[levelIndex] : evoLevelConfig[levelIndex];
    const result = this.state.userResponse.filter(
      item => item[currentLevel] && item[currentLevel].hierarchyId === selectedHierarchyId
    );
    if (result.length === 0 || result.some(e => e[nextLevel] === null)) {
      const hierarchyData = await this.getUserHierarchyData(selectedHierarchyId, nextTierType);
      const nextLevelData = hierarchyData.map(result => ({
        mainLine: result.value,
        name,
        hierarchyId: result.hierarchyId,
        id: result.hierarchyId,
      }));
      this.updateOrgState(stateLevel, nextLevelData);
    } else {
      const uniqueHierarchies = this.parseHierarchyValues(result.map(hierarchy => hierarchy[nextLevel]));
      const nextLevelData = uniqueHierarchies.map(hierarchy => ({
        mainLine: hierarchy.value,
        name: hierarchy.name,
        hierarchyId: hierarchy.hierarchyId,
        id: hierarchy.hierarchyId,
      }));
      this.updateOrgState(stateLevel, nextLevelData);
    }
  }
  
  updateOrgState(index, items) {
    this.setState(prevState => ({
      orgState: [
        ...prevState.orgState.slice(0, index),
        {
          ...prevState.orgState[index],
          items: [this.state.allOption, ...prevState.orgState[index].items, ...items],
        },
        ...prevState.orgState.slice(index + 1)
      ]
    }));
  }

  async getUserHierarchyData(selectedHierarchyId, nextTierType) {
    if (nextTierType) this.toggleLoading(nextTierType);
    const authToken = JSON.parse(sessionStorage.getItem("state")).auth.accessToken;
    try {
      const hierarchyData = await getUserHierarchyData(authToken,selectedHierarchyId);
      if (nextTierType) this.toggleLoading(nextTierType);
      return hierarchyData.data;
    } catch (error) {
      console.error("Error fetching hierarchy data:", error);
    }
  }

  // handler called when the user selects or deselects a merchant in the merchant list
  onMerchantSelected(selectionId) {
   const selectedValues = this.state.orgState.map(e => e.selectedItems);
    console.log("SELECTED selectedValues ", selectedValues);
    this.setState({selectedOrgIds : selectedValues}, () => {this.handleHierarchyCallback()});
    this.toggleMerchantItem(selectionId);
    this.updateSelectionStatus();
   
  }

  // handler called when user initiates a search by FULL mid to select a hierarchy starting with MID instead of drilling down from corp
  onLazySearchByMID(MID) {
    const trimmedMid = MID && MID.replace(/(^[0 ]+)|(^\s+|\s+$)/g, '');
    this.setState({enteredMid: trimmedMid});
    this.handleHierarchyCallback(trimmedMid);
  }

  // return the selected item
  getSelectedItem(tierType) {
    return this.state.orgState[tierType].selectedItems[0];
  }

  // find the last selected item in this row (i.e., left most column not set to All/Select )
  getLastSelectedItem(state) {
    const columns = [...state.orgState].reverse();
    const col = columns.find(x => x.selectedItems.length > 0 && (x.selectedItems[0].id !== counterpart('globalTranslate.globalSelector.select') || x.selectedItems[0].id !== 'All'));
    return col;
  }

  // determine whether to show 'All' or 'Select' caption at a given tier of the hierarchy
  getAllOrSelectCaption(state, tierType) {
    let prevTierSelection;
    let hasParentTierAccess = false;
    let disallowAllMerchantsForChain000 = false;
    if ((this.props.canViewGpnAccountsSelector && tierType === GPNOrgTypes.CORP) || (this.props.canViewHpyAccountsSelector && tierType === HPYOrgTypes.CHAIN) || (this.props.canViewEvoAccountsSelector && tierType === EVOOrgTypes.CHAIN)) {
      hasParentTierAccess = false;
    } else {
      prevTierSelection = state.orgState[tierType - 1]?.selectedItems[0];
      if (!prevTierSelection) {
        hasParentTierAccess = true;
      } else {
        hasParentTierAccess = prevTierSelection.hasAccess;
      }
      
      disallowAllMerchantsForChain000 = (tierType === this.state.levelType.MERCHANT &&
                                        prevTierSelection && prevTierSelection.mainLine === '000' &&
                                        this.state.EXTERNAL_ROLES.includes(this.props.targetRole));
    }

    if(hasParentTierAccess || !this.props.targetRole && !disallowAllMerchantsForChain000){
      if(this.props.canViewEvoAccountsSelector) return this.props.selectorConfig[getEvoOrgName(tierType)]?.defaultsTo;
      else if(this.props.canViewHpyAccountsSelector) return this.props.selectorConfig[getHpyOrgName(tierType)]?.defaultsTo;
      else return this.props.selectorConfig[getGpnOrgName(tierType)]?.defaultsTo;
    }
    else return counterpart('globalTranslate.globalSelector.select');
  }

  parseHierarchyValues = (hierarchies) => {
    const uniqueHierarchies = hierarchies.filter((item, index, array) => {
      const currentIndex = array.findIndex((el) => el.hierarchyId === item.hierarchyId);
      return currentIndex === index;
    });
    return uniqueHierarchies.map((item) => {
      if(item !== null) {
      return Object.assign({}, item, {
        mainLine: item.value,
        name:item.name,
        hierarchyId:item.hierarchyId,
        id:item.hierarchyId,
      });
      } else {
        return '';
      }
      
    });
  }

  loadInitialHierarchies(){
    const auth = sessionStorage.getItem("__gp_auth_token__");
    const { canViewEvoAccountsSelector, canViewGpnAccountsSelector,canViewHpyAccountsSelector } = this.props;
    getAuthenticatedUser(auth,true).then((userResponse) => { 
      const acqCodeKey= canViewGpnAccountsSelector ? "GPN" : canViewHpyAccountsSelector ? "HPY" : canViewEvoAccountsSelector ? "EMD" : "GPN";
      const hierarchies = userResponse.data.hierarchyMap[acqCodeKey];
       let levelKey;
      if (canViewEvoAccountsSelector) {
        levelKey = 'level4';
      } else if (canViewGpnAccountsSelector) {
        levelKey = 'level6';
      }else if(canViewHpyAccountsSelector){
        levelKey= 'level2';
      }

      if(levelKey){
        this.setState({
          userResponse: hierarchies,
          [levelKey] : this.parseHierarchyValues(hierarchies.map(e => e[levelKey])),
        }, () => {
        this.setState(prevState => ({
          orgState: [
            {
              ...prevState.orgState[0],
              items: [this.state.allOption, ...prevState.orgState[0].items, ...this.state[levelKey], ]
            },
            ...prevState.orgState.slice(1)
          ]
        }));
        });
      }

    });  
  }

  // determine whether the user must fill in a selection to pass row validation
  isSelectionRequired(state, tierType) {
    return this.getAllOrSelectCaption(state, tierType) === counterpart('globalTranslate.globalSelector.select');
  }

  // find an item to select based on id (hierarchyCode)
  findItemToSelect(tierType, id) {
    return this.state.orgState[tierType].items.find(i => i.id === id);
  }

  // trigger the callback to notify parent component of change to selected hierarchy
  handleHierarchyCallback(manualSearchMid) {
    let state;
    // call setState to ensure callback fires in order it was called after any other batched setState calls
    const selectedValues = this.state.orgState.map(e =>e.selectedItems);
    this.setState(prevState => {
      state = prevState;
      return { ...prevState };
    }, () => this.props.hierarchySelectionCallback(state.rowKey, selectedValues, manualSearchMid, state.orgState));
  }

  // toggle merchant item between selected/unselect
  toggleMerchantItem(selectionId) {
    this.setState(produce(draft => {
      const merchantTier = draft.orgState[this.state.levelType.MERCHANT];
      if(merchantTier !== null){
        if (selectionId === 'All') {
          const merchantItem = this.findItemToSelect(this.state.levelType.MERCHANT, selectionId);
          const selected =  merchantTier.selectedItems.find(selectedMerchant => selectedMerchant.id === merchantItem.id);
          merchantTier.selectedItems = merchantTier.selectedItems.filter(selectedMerchant => selectedMerchant.id == 'All');
          if (!selected) {
            merchantTier.selectedItems.push(merchantItem);
          }
        } else {
          const merchantItem = this.findItemToSelect(this.state.levelType.MERCHANT, selectionId);
          const selected = merchantTier.selectedItems.find(selectedMerchant => selectedMerchant.id === merchantItem.id);
          merchantTier.selectedItems = merchantTier.selectedItems.filter(selectedMerchant => selectedMerchant.id !== 'All');
          if (selected) {
            merchantTier.selectedItems = merchantTier.selectedItems.filter(selectedMerchant => selectedMerchant.id !== selected.id);
          } else {
            merchantTier.selectedItems.push(merchantItem);
          }
        }
      }
      
    }));
  }

  // update the selected item at the given tier
  updateCurrentTierSelection(tierType, itemToSelect) {
    this.setState(produce(draft => {
      const currentTierState = draft.orgState[tierType];
      currentTierState.selectedItems = itemToSelect ? [itemToSelect] : [];
    }));
  }

  // returns an object with orgType status to help with error notification
  buildOrgStatusMap(state) {
    const selectedRequiredMap = {};
    state.orgState.forEach(tier => {
      selectedRequiredMap[tier.orgType] = {
        required: this.isSelectionRequired(state, tier.orgType),
        selected: tier.selectedItems.length > 0,
      };
    });
    selectedRequiredMap.rowErrorCount = Object.values(selectedRequiredMap).filter(orgStatus => orgStatus.required && !orgStatus.selected).length;
    return selectedRequiredMap;
  }

  // updates misc calculated states for the row based on current selections
  updateSelectionStatus() {
    this.setState(produce(draft => {
      draft.isValid = !draft.orgState.some(tier => this.isSelectionRequired(draft, tier.orgType) && tier.selectedItems.length === 0);
      const currentSelection = [...draft.orgState].reverse().find(o => o.selectedItems.length > 0);
      let currentOrgIds = currentSelection ? currentSelection.selectedItems.filter(o => o.orgId).map(o => o.orgId) : [];
      const currentOrgTypes = currentSelection ? currentSelection.selectedItems.filter(o => o.orgType > -1).map(o => o.orgType) : [];
      if (this.props.isGlobalSelector && !currentOrgIds.length && currentSelection && currentSelection.selectedItems.length) {
        // user does not have direct access to the current organization selected, so get the highest
        // tier organization(s) they have direct access to that are descendants of the current selection
        // const selectedHierarchyCode = currentSelection.selectedItems[0].hierarchyCode;
        currentOrgIds = []; // this.props.getDirectTopLevelOrganizations(selectedHierarchyCode).map(x => x.orgId);
      }
      draft.selectedOrgIds = draft.isValid ? currentOrgIds : [];
      draft.selectedOrgTypes = draft.isValid ? currentOrgTypes : [];
      draft.orgTypeStatusMap = this.buildOrgStatusMap(draft);
    }));
  }

   // helper to toggle loading status of a dropdown as well as lock the row
   toggleLoading(tierType) {
    this.setState(produce(draft => {
      const isLoading = !draft.orgState[tierType].isLoading;
      draft.orgState[tierType].isLoading = isLoading;
      draft.isLocked = isLoading;
    }));
  }

  // parent org selection was changed, so clear and reset descendant tiers
  clearAndResetDescendants(parentOrgType) {
    this.setState(produce(draft => {
      for (let i = parentOrgType + 1; i <= this.state.levelType.MERCHANT; i += 1) {
        const org = draft.orgState[i];
        org.items = [];
        org.selectedItems = [];
      }
    }));
  }

  attachBindings() {
    this.onOrgSelected = this.onOrgSelected.bind(this);
    this.onMerchantSelected = this.onMerchantSelected.bind(this);
    this.clearAndResetDescendants = this.clearAndResetDescendants.bind(this);
    this.onInitializeRow = this.onInitializeRow.bind(this);
    this.onLazySearchByMID = this.onLazySearchByMID.bind(this);
    this.buildOrgStatusMap = this.buildOrgStatusMap.bind(this);
    this.getSelectedItem = this.getSelectedItem.bind(this);
    this.getAllOrSelectCaption = this.getAllOrSelectCaption.bind(this);
    this.getLastSelectedItem = this.getLastSelectedItem.bind(this);
    this.isSelectionRequired = this.isSelectionRequired.bind(this);
    this.findItemToSelect = this.findItemToSelect.bind(this);
    this.loadInitialHierarchies = this.loadInitialHierarchies.bind(this);
    this.parseHierarchyValues = this.parseHierarchyValues.bind(this);
    this.toggleMerchantItem = this.toggleMerchantItem.bind(this);
    this.updateCurrentTierSelection = this.updateCurrentTierSelection.bind(this);
    this.updateSelectionStatus = this.updateSelectionStatus.bind(this);
    this.handleHierarchyCallback = this.handleHierarchyCallback.bind(this);
    this.toggleLoading = this.toggleLoading.bind(this);
  }

  render() {
    const { orgTypeStatusMap } = this.state;
    const orgSelectors = this.state.orgState.map((orgState) => {
      const selected = orgState.selectedItems;
      let selectedTerm = selected && selected.length ? selected[0].mainLine : this.getAllOrSelectCaption(this.state, orgState.orgType); // this.props.selectorConfig[orgState.tierName].defaultsTo;
      if (selected.length > 1) {
        selectedTerm = `${selectedTerm} + ${selected.length - 1} more`;
      }
      if (orgState.orgType === this.state.levelType.MERCHANT) {
        if (selected.length === 0 && orgState.items.length === 0) {
          selectedTerm = 'All';
        }
      }
      // const enabled = orgState.orgType === GPNOrgTypes.CORP || orgState.orgType === GPNOrgTypes.MERCHANT ? true : this.state.orgState[orgState.orgType - 1]?.selectedItems?.length > 0;
       let enabled;
        if ((this.props.canViewEvoAccountsSelector && orgState.orgType === EVOOrgTypes.GROUP) || 
            (this.props.canViewGpnAccountsSelector && orgState.orgType === GPNOrgTypes.CORP) ||(this.props.canViewHpyAccountsSelector && orgState.orgType === HPYOrgTypes.CHAIN)||
            orgState.orgType === this.state.levelType.MERCHANT) {
              enabled = true;
        } else {
          enabled = this.state.orgState[orgState.orgType - 1]?.selectedItems?.length > 0 ;
        }
        if(this.state.enteredMid.length > 0 ||  this.props.prepopulatedMerchantId?.length > 0){
        enabled = false;
        }
      const onSelect = orgState.orgType < this.state.levelType.MERCHANT ? this.onOrgSelected : this.onMerchantSelected;
      const needsInput = (this.props.accordionErrors) ? orgTypeStatusMap[orgState.orgType].required && !orgTypeStatusMap[orgState.orgType]?.selected : false;
      
      return (
        <OrgSelectorWidgetAccounts
          key={orgState.orgType}
          labelText={orgState.tierName.toUpperCase()}
          isGlobalSelector
          dataList={orgState.items}
          enabled={enabled}
          onChange={() => 0}
          handleSelect={(selection) => onSelect(selection, orgState.orgType)}
          selectedTerm={selectedTerm}
          selectedItems={selected}
          isLoading={this.state.isIdLoading ||orgState.isLoading}
          isLocked={this.state.isLocked || (orgState.orgType < this.state.levelType.MERCHANT && this.state.isMidSearchLocked)}
          forceCloseOnSelect={orgState.orgType !== this.state.levelType.MERCHANT}
          forceCloseOnSelectAll
          onLazyLoadSearch={this.onLazySearchByMID}
          enableLazyLoadSearch={orgState.orgType === this.state.levelType.MERCHANT && orgState.items.length === 0 && orgState.selectedItems.length === 0}
          lazySearchPlaceholder={counterpart('globalTranslate.reports.enterFullMIDAndPressEnter')}
          needsInput={needsInput}
          placeholder={counterpart(`globalTranslate.common.search${orgState.tierName[0].toUpperCase() + orgState.tierName.slice(1)}`)}
          chainSelected={this.state.orgState[4] && this.state.orgState[4].selectedItems.length > 0}
          prepopulatedMerchantId={this.props.prepopulatedMerchantId}
          searchTerm={this.state.searchTerm}
          enteredMid={this.state.enteredMid}
          isBaseLevelSelected={this.state.orgState[0]?.selectedItems.length > 0}
          canViewGpnAccountsSelector={this.props.canViewGpnAccountsSelector}
          canViewHierarchySelector={this.props.canViewHierarchySelector}
        />
      );
    });

    return (
      <div className="global-selector-widgets hidden-l" id="global-selector-widgets-mobile">
        {orgSelectors}
      </div>
    );
  }
}

OrgHierarchySelectorAccountsRow.propTypes = {
  initialSelections: PropTypes.array.isRequired,
  hierarchySelectionCallback: PropTypes.func.isRequired,
  lookupOrganizations: PropTypes.func.isRequired,
  selectorConfig: PropTypes.object.isRequired,
  rowKey: PropTypes.number.isRequired,
  enableLazyLoading: PropTypes.bool,
  targetRole: PropTypes.string,
  accordionErrors: PropTypes.number.isRequired,
  isGlobalSelector: PropTypes.bool.isRequired,
  getDirectTopLevelOrganizations: PropTypes.func.isRequired,
};

OrgHierarchySelectorAccountsRow.defaultProps = {
  initialSelections: [],
  lookupOrganizations: () => {},
  onSelectionChanged: () => 1,
  preloadEmptySelectors: false,
  enableLazyLoading: false,
  targetRole: '',
  corp: { defaultsTo: 'All', required: false },
    region: { defaultsTo: 'All', required: false },
    principal: { defaultsTo: 'All', required: false },
    associate: { defaultsTo: 'All', required: false },
    chain: { defaultsTo: 'All', required: false },
    merchant: { defaultsTo: 'All', required: false },
};

export default OrgHierarchySelectorAccountsRow;
